var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { CoreConfig } from '../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { useAnimation } from '../Animations/AnimationHooks';
import { AnimatedPressable } from './AnimatedPressable';
export const SimpleButtonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.simpleButton
})((_a) => {
    var { style, onPress, children, containerStyle, disabled, disabledOpacity } = _a, otherProps = __rest(_a, ["style", "onPress", "children", "containerStyle", "disabled", "disabledOpacity"]);
    const [btnOpacity, setBtnOpacity] = useAnimation({ initialValue: 1, duration: 150, nativeDriver: true });
    const handlePress = useCallback(() => {
        if (disabled) {
            return;
        }
        onPress === null || onPress === void 0 ? void 0 : onPress();
        setBtnOpacity(0.6).then(() => setBtnOpacity(1));
    }, [onPress, disabled]);
    const onBtnMouseEnter = useCallback(() => !disabled && setBtnOpacity(0.6), [disabled]);
    const onBtnMouseLeave = useCallback(() => setBtnOpacity(1), []);
    return (_jsx(AnimatedPressable, Object.assign({ style: [style === null || style === void 0 ? void 0 : style.container, containerStyle, { opacity: btnOpacity }, disabled && { opacity: typeof disabledOpacity === 'number' ? disabledOpacity : 0.8 }], onPress: handlePress, disabled: disabled, onMouseEnter: onBtnMouseEnter, onMouseLeave: onBtnMouseLeave }, otherProps, { children: children })));
});
